export default     {
    path: 'clients',
    name: 'clientsControl',
    component: () => import(/* webpackChunkName: "ClientsControl" */ '@/views/admin/Control/Clients/ClientsControl.vue'),
    children:[
        {
            path: 'client-list',
            name: 'ClientsListSettings',
            component: () => import(/* webpackChunkName: "ClientsListSettings" */ '@/views/admin/Control/Clients/ClientsListSettings.vue'),
        },
        {
            path: 'client-user',
            name: 'UserClientSettings',
            component: () => import(/* webpackChunkName: "ClientsSettings" */ '@/views/admin/Control/Clients/UserClientSettings.vue'),
        },
    ]
};
